// Change line 1 to:
import React, { useEffect, useState, useCallback } from 'react';

// Change line 2 to include ChevronLeft, ChevronRight:
import { CheckCircle, Package, FileText, Globe, Truck, Award, Droplets, Layers, Filter, SortAsc, Scale, RotateCw, Shield, Scissors, CheckCheck, ChevronLeft, ChevronRight } from 'lucide-react';
const ProcessingStyles = () => {
  useEffect(() => {
    const css = `
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Sora:wght@400;500;600;700;800&display=swap');
      
      :root {
        --primary-blue: #0073b1;
        --primary-green: #6bbe44;
        --dark-text: #0a1828;
        --gray-text: #4a5568;
        --light-bg: #fafbfc;
      }

      * {
        box-sizing: border-box;
      }

      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes slideInLeft {
        from {
          opacity: 0;
          transform: translateX(-30px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      @keyframes slideInRight {
        from {
          opacity: 0;
          transform: translateX(30px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      @keyframes float {
        0%, 100% {
          transform: translateY(0px);
        }
        50% {
          transform: translateY(-10px);
        }
      }

      @keyframes flowProgress {
        to {
          height: 100%;
        }
      }

      .processing-page {
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
        min-height: 100vh;
        overflow-x: hidden;
      }
      .proc-gallery-section {
        margin-bottom: 80px;
        animation: fadeInUp 0.8s ease;
      }
      
      .slider-container {
        position: relative;
        border-radius: 24px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 77, 115, 0.15);
        aspect-ratio: 16/9;
        max-height: 600px;
        background: #000;
        
        /* --- ضيف السطرين دول عشان يجي في النص --- */
        max-width: 1000px;  /* نفس عرض الـ Flow اللي تحته */
        margin: 0 auto;     /* عشان يتوسطن في الصفحة */
        /* -------------------------------------- */
      }

      .slide-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .slide-overlay {
        position: absolute;
        bottom: 0; left: 0; right: 0;
        background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%);
        padding: 60px 40px 40px;
        color: white;
      }

      .slide-caption {
        font-family: 'Sora', sans-serif;
        font-size: clamp(1.2rem, 3vw, 1.8rem);
        font-weight: 600;
        text-shadow: 0 2px 4px rgba(0,0,0,0.3);
      }

      .nav-button {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(255, 255, 255, 0.9);
        border: none;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--primary-blue);
        transition: all 0.2s ease;
        z-index: 10;
      }

      .nav-button:hover { background: white; transform: translateY(-50%) scale(1.1); }
      .nav-button.left { left: 20px; }
      .nav-button.right { right: 20px; }

      .dots-container {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 10px;
        z-index: 10;
      }

      .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: rgba(255,255,255,0.5);
        border: none;
        cursor: pointer;
        transition: all 0.3s;
      }
      .dot.active { background: var(--primary-green); transform: scale(1.2); }
      /* Hero Section */
      .processing-hero {
        background: linear-gradient(135deg, #0073b1 0%, #004d73 100%);
        padding: 100px 24px 70px;
        text-align: center;
        position: relative;
        overflow: hidden;
      }

      .processing-hero::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        opacity: 0.3;
      }

      .processing-hero-content {
        position: relative;
        z-index: 1;
        max-width: 900px;
        margin: 0 auto;
        animation: fadeInUp 0.6s ease;
      }

      .processing-hero h1 {
        font-family: 'Sora', sans-serif;
        font-size: clamp(2.2rem, 6vw, 4rem);
        color: white;
        margin-bottom: 20px;
        font-weight: 800;
        letter-spacing: -1px;
        animation: fadeInUp 0.6s ease;
      }

      .processing-hero-subtitle {
        font-size: clamp(1.05rem, 2.5vw, 1.4rem);
        color: rgba(255, 255, 255, 0.95);
        line-height: 1.7;
        animation: fadeInUp 0.6s ease 0.1s;
        animation-fill-mode: backwards;
        max-width: 800px;
        margin: 0 auto;
      }

      /* Main Content Container */
      .processing-container {
        max-width: 1280px;
        margin: 0 auto;
        padding: 60px 24px;
      }

      /* Section Headers */
      .section-header {
        text-align: center;
        margin-bottom: 50px;
        animation: fadeInUp 0.6s ease;
      }

      .section-title {
        font-family: 'Sora', sans-serif;
        font-size: clamp(2rem, 5vw, 3rem);
        color: var(--dark-text);
        margin-bottom: 15px;
        font-weight: 700;
        letter-spacing: -0.5px;
        background: linear-gradient(135deg, #0a1828 0%, #0073b1 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .section-subtitle {
        font-size: clamp(1rem, 2vw, 1.2rem);
        color: var(--gray-text);
        max-width: 700px;
        margin: 0 auto;
        line-height: 1.7;
      }

      /* Processing Flow Map */
      .processing-flow {
        position: relative;
        max-width: 1000px;
        margin: 0 auto 60px;
        padding: 40px 0;
      }

      /* Animated Path Line */
      .flow-path {
        position: absolute;
        top: 0;
        left: 50%;
        width: 3px;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 115, 177, 0.2), rgba(107, 190, 68, 0.2));
        transform: translateX(-50%);
      }

      .flow-path::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0;
        background: linear-gradient(180deg, var(--primary-blue), var(--primary-green));
        animation: flowProgress 2.5s ease-out forwards;
        box-shadow: 0 0 15px rgba(0, 115, 177, 0.4);
      }

      .flow-step {
        position: relative;
        display: flex;
        align-items: center;
        gap: 30px;
        margin-bottom: 50px;
        animation: slideInLeft 0.5s ease;
        animation-fill-mode: backwards;
      }

      .flow-step:nth-child(even) {
        flex-direction: row-reverse;
        animation-name: slideInRight;
      }

      .flow-step:nth-child(1) { animation-delay: 0.1s; }
      .flow-step:nth-child(2) { animation-delay: 0.15s; }
      .flow-step:nth-child(3) { animation-delay: 0.2s; }
      .flow-step:nth-child(4) { animation-delay: 0.25s; }
      .flow-step:nth-child(5) { animation-delay: 0.3s; }
      .flow-step:nth-child(6) { animation-delay: 0.35s; }
      .flow-step:nth-child(7) { animation-delay: 0.4s; }
      .flow-step:nth-child(8) { animation-delay: 0.45s; }
      .flow-step:nth-child(9) { animation-delay: 0.5s; }

      .flow-step:last-child {
        margin-bottom: 0;
      }

      /* Step Number Circle */
      .step-number {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 65px;
        height: 65px;
        background: linear-gradient(135deg, var(--primary-blue), var(--primary-green));
        color: white;
        border-radius: 50%;
        font-size: 1.6rem;
        font-weight: 700;
        box-shadow: 0 6px 20px rgba(0, 115, 177, 0.35);
        z-index: 10;
        border: 4px solid white;
        transition: all 0.3s ease;
      }

      .flow-step:hover .step-number {
        transform: translateX(-50%) scale(1.1);
        box-shadow: 0 8px 25px rgba(0, 115, 177, 0.5);
      }

      /* Step Content Card */
      .step-content {
        flex: 1;
        background: white;
        padding: 30px 35px;
        border-radius: 18px;
        box-shadow: 0 8px 30px rgba(0, 77, 115, 0.08);
        border: 2px solid rgba(0, 115, 177, 0.1);
        transition: all 0.3s ease;
        position: relative;
        max-width: 420px;
      }

      .flow-step:nth-child(odd) .step-content {
        margin-right: auto;
        margin-left: 0;
      }

      .flow-step:nth-child(even) .step-content {
        margin-left: auto;
        margin-right: 0;
      }

      /* Arrow connecting card to center */
      .step-content::before {
        content: '';
        position: absolute;
        top: 50%;
        width: 35px;
        height: 2px;
        background: linear-gradient(90deg, var(--primary-blue), var(--primary-green));
        transform: translateY(-50%);
      }

      .flow-step:nth-child(odd) .step-content::before {
        right: -35px;
      }

      .flow-step:nth-child(even) .step-content::before {
        left: -35px;
      }

      /* Arrow head */
      .step-content::after {
        content: '';
        position: absolute;
        top: 50%;
        width: 0;
        height: 0;
        border-style: solid;
        transform: translateY(-50%);
      }

      .flow-step:nth-child(odd) .step-content::after {
        right: -43px;
        border-width: 7px 0 7px 8px;
        border-color: transparent transparent transparent var(--primary-green);
      }

      .flow-step:nth-child(even) .step-content::after {
        left: -43px;
        border-width: 7px 8px 7px 0;
        border-color: transparent var(--primary-green) transparent transparent;
      }

      .step-content:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 45px rgba(0, 77, 115, 0.12);
        border-color: var(--primary-blue);
      }

      .step-title {
        font-family: 'Sora', sans-serif;
        font-size: clamp(1.2rem, 2vw, 1.5rem);
        color: var(--dark-text);
        margin-bottom: 10px;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .step-icon {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(0, 115, 177, 0.1), rgba(107, 190, 68, 0.1));
        border-radius: 8px;
        flex-shrink: 0;
      }

      .step-description {
        font-size: clamp(0.95rem, 1.5vw, 1.05rem);
        color: var(--gray-text);
        line-height: 1.6;
      }

      /* Mobile Responsive for Flow */
      @media (max-width: 768px) {
        .processing-flow {
          padding: 30px 0 30px 0;
          margin-left: 0;
        }

        .flow-path {
          left: 35px;
          transform: none;
          width: 2px;
        }

        .flow-step {
          flex-direction: row !important;
          align-items: flex-start !important;
          gap: 0;
          margin-bottom: 45px;
          padding: 0;
          padding-left: 0;
        }

        .step-number {
          position: relative;
          left: 0;
          top: 0;
          transform: none;
          width: 55px;
          height: 55px;
          font-size: 1.4rem;
          border: 3px solid white;
          flex-shrink: 0;
          margin-left: 8px;
          margin-right: 18px;
        }

        .flow-step:hover .step-number {
          transform: scale(1.05);
        }

        .step-content {
          max-width: 100%;
          margin: 0 !important;
          padding: 20px 18px;
          width: calc(100% - 85px);
          flex: 1;
        }

        .step-content::before,
        .step-content::after {
          display: none;
        }

        .step-title {
          font-size: 1.15rem;
          flex-wrap: wrap;
        }

        .step-description {
          font-size: 0.95rem;
        }
      }

      /* Quality Badge */
      .quality-badge {
        background: linear-gradient(135deg, #6bbe44 0%, #5aa838 100%);
        color: white;
        padding: 45px 35px;
        border-radius: 20px;
        text-align: center;
        margin: 50px 0;
        box-shadow: 0 12px 40px rgba(107, 190, 68, 0.25);
        position: relative;
        overflow: hidden;
        animation: fadeInUp 0.6s ease;
      }

      .quality-badge::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
        animation: float 6s ease-in-out infinite;
      }

      .quality-badge-content {
        position: relative;
        z-index: 1;
      }

      .quality-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 70px;
        height: 70px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        margin-bottom: 18px;
        backdrop-filter: blur(10px);
      }

      .quality-title {
        font-family: 'Sora', sans-serif;
        font-size: clamp(1.6rem, 3vw, 2.2rem);
        font-weight: 700;
        margin-bottom: 12px;
        letter-spacing: -0.5px;
      }

      .quality-text {
        font-size: clamp(1rem, 2vw, 1.2rem);
        opacity: 0.95;
        line-height: 1.7;
        max-width: 800px;
        margin: 0 auto;
      }

      /* Logistics Section */
      .logistics-section {
        background: white;
        padding: 50px 35px;
        border-radius: 20px;
        box-shadow: 0 12px 40px rgba(0, 77, 115, 0.1);
        border: 2px solid rgba(0, 115, 177, 0.1);
        animation: fadeInUp 0.6s ease;
      }

      .logistics-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
        gap: 25px;
        margin-top: 35px;
      }

      .logistics-item {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 22px;
        background: linear-gradient(135deg, rgba(0, 115, 177, 0.03), rgba(107, 190, 68, 0.03));
        border-radius: 16px;
        border: 2px solid rgba(0, 115, 177, 0.08);
        transition: all 0.3s ease;
      }

      .logistics-item:hover {
        transform: translateX(6px);
        background: linear-gradient(135deg, rgba(0, 115, 177, 0.08), rgba(107, 190, 68, 0.08));
        border-color: var(--primary-blue);
        box-shadow: 0 6px 20px rgba(0, 115, 177, 0.12);
      }

      .logistics-icon {
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, var(--primary-blue), var(--primary-green));
        border-radius: 12px;
        color: white;
        box-shadow: 0 4px 12px rgba(0, 115, 177, 0.25);
      }

      .logistics-content h4 {
        font-family: 'Sora', sans-serif;
        font-size: clamp(1.1rem, 2vw, 1.2rem);
        color: var(--dark-text);
        margin-bottom: 8px;
        font-weight: 600;
      }

      .logistics-content p {
        font-size: clamp(0.95rem, 1.5vw, 1rem);
        color: var(--gray-text);
        line-height: 1.6;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .processing-hero {
          padding: 80px 20px 60px;
        }

        .processing-container {
          padding: 50px 20px;
        }

        .section-header {
          margin-bottom: 40px;
        }

        .quality-badge {
          padding: 35px 25px;
          margin: 40px 0;
        }

        .quality-icon {
          width: 60px;
          height: 60px;
        }

        .logistics-section {
          padding: 35px 20px;
        }

        .logistics-grid {
          grid-template-columns: 1fr;
          gap: 20px;
        }

        .logistics-item {
          padding: 20px;
        }

        .logistics-item:hover {
          transform: translateY(-3px);
        }
      }

      @media (max-width: 480px) {
        .processing-hero {
          padding: 70px 16px 50px;
        }

        .processing-container {
          padding: 40px 16px;
        }

        .processing-flow {
          padding: 25px 0 25px 0;
        }

        .flow-path {
          left: 32px;
        }

        .step-number {
          width: 50px;
          height: 50px;
          font-size: 1.3rem;
          margin-left: 7px;
          margin-right: 15px;
        }

        .step-content {
          padding: 18px 15px;
          width: calc(100% - 75px);
        }

        .step-title {
          font-size: 1.1rem;
        }

        .step-description {
          font-size: 0.9rem;
        }

        .quality-badge {
          padding: 30px 20px;
        }

        .logistics-section {
          padding: 30px 16px;
        }

        .logistics-item {
          padding: 18px;
          gap: 15px;
        }

        .logistics-icon {
          width: 44px;
          height: 44px;
        }
      }
    `;

    const styleEl = document.createElement('style');
    styleEl.id = 'processing-styles';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);

    return () => {
      const el = document.getElementById('processing-styles');
      if (el) {
        document.head.removeChild(el);
      }
    };
  }, []);

  return null;
};
const ProcessingGallery = () => {
  const [current, setCurrent] = useState(0);
  
  const images = [
    { url: '/images/proc1.webp', caption: 'Advanced Processing Lines' },
    { url: '/images/proc2.webp', caption: 'Quality Control Standards' },
    { url: '/images/proc3.webp', caption: 'Hygienic Packaging Areas' }
  ];

  const nextSlide = useCallback(() => {
    setCurrent((prev) => (prev + 1) % images.length);
  }, [images.length]);

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  // Auto-play (Optional)
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <div className="proc-gallery-section">
      <div className="section-header">
        <h2 className="section-title">Facility Tour</h2>
        <p className="section-subtitle">Inside our state-of-the-art processing plant</p>
      </div>
      
      <div className="slider-container">
        <img 
          src={images[current].url} 
          alt={images[current].caption} 
          className="slide-image"
        />
        <div className="slide-overlay">
          <div className="slide-caption">{images[current].caption}</div>
        </div>

        <button onClick={prevSlide} className="nav-button left"><ChevronLeft /></button>
        <button onClick={nextSlide} className="nav-button right"><ChevronRight /></button>

        <div className="dots-container">
          {images.map((_, idx) => (
            <button 
              key={idx} 
              className={`dot ${current === idx ? 'active' : ''}`}
              onClick={() => setCurrent(idx)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
function Processing() {
  const processingSteps = [
    { number: 1, title: 'Cleaning', description: 'Initial removal of impurities and foreign materials using advanced cleaning systems.', icon: Droplets },
    { number: 2, title: 'Sifting', description: 'Separating materials by size using precision sifting equipment for optimal quality.', icon: Layers },
    { number: 3, title: 'Sieving', description: 'Fine-mesh screening to ensure uniform particle size and consistency.', icon: Filter },
    { number: 4, title: 'Sorting', description: 'Automated and manual sorting to remove defective materials and ensure grade standards.', icon: SortAsc },
    { number: 5, title: 'Gravity Separation', description: 'Utilizing density differences to separate materials and remove unwanted particles.', icon: Scale },
    { number: 6, title: 'Indented Cylinders', description: 'Length-based separation using rotating cylinders for precise grading.', icon: RotateCw },
    { number: 7, title: 'Metal Detection', description: 'State-of-the-art metal detectors ensuring zero contamination in final products.', icon: Shield },
    { number: 8, title: 'Cutting per Specification', description: 'Custom cutting and processing to meet your exact B2B requirements.', icon: Scissors },
    { number: 9, title: 'Final Quality Inspection', description: 'Comprehensive quality checks ensuring every batch meets our "Fit for Purpose" standard.', icon: CheckCheck }
  ];

  const logisticsFeatures = [
    {
      icon: <Package size={24} />,
      title: 'Bulk Packaging',
      description: 'Optimized packaging solutions for efficient container loading and transport.'
    },
    {
      icon: <FileText size={24} />,
      title: 'Export Documentation',
      description: 'Complete documentation handling including certificates, customs, and compliance.'
    },
    {
      icon: <Globe size={24} />,
      title: 'Global Shipping',
      description: 'Reliable shipments to EU, USA, Asia, and MENA regions with proven logistics partners.'
    },
    {
      icon: <Truck size={24} />,
      title: 'Supply Stability',
      description: 'Consistent supply chains and long-term contract options for business continuity.'
    }
  ];

  return (
    <>
      <ProcessingStyles />
      <div className="processing-page">
        {/* Hero Section */}
        <section className="processing-hero">
          <div className="processing-hero-content">
            <h1>Processing Excellence</h1>
            <p className="processing-hero-subtitle">
              Our state-of-the-art processing facility delivers transparent, quality-driven operations 
              designed specifically for B2B requirements. From raw materials to export-ready products, 
              we ensure excellence at every stage.
            </p>
          </div>
        </section>

        {/* Main Content */}
        <div className="processing-container">
        <ProcessingGallery />
          {/* Processing Flow Section */}
          <div className="section-header">
            <h2 className="section-title">Our Processing Flow</h2>
            <p className="section-subtitle">
              A systematic, transparent approach with multiple quality checkpoints ensuring 
              consistently high-quality batches that meet your specifications.
            </p>
          </div>

          <div className="processing-flow">
            {/* Animated center path line */}
            <div className="flow-path"></div>
            
            {processingSteps.map((step) => {
              const IconComponent = step.icon;
              return (
                <div key={step.number} className="flow-step">
                  <div className="step-number">{step.number}</div>
                  <div className="step-content">
                    <h3 className="step-title">
                      {step.title}
                    </h3>
                    <p className="step-description">{step.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Quality Badge */}
          <div className="quality-badge">
            <div className="quality-badge-content">
              <div className="quality-icon">
                <Award size={40} />
              </div>
              <h3 className="quality-title">Fit for Purpose – Every Time</h3>
              <p className="quality-text">
                Multiple checkpoints throughout our processing flow ensure that every batch 
                meets the highest quality standards and your exact specifications. Our commitment 
                to excellence means you receive products that are ready for immediate use.
              </p>
            </div>
          </div>

          {/* Logistics & Export Section */}
          <section className="logistics-section">
            <div className="section-header" style={{ marginBottom: '20px' }}>
              <h2 className="section-title">Logistics & Export</h2>
              <p className="section-subtitle">
                End-to-end export support ensuring your products reach their destination 
                safely, on time, and with complete documentation.
              </p>
            </div>

            <div className="logistics-grid">
              {logisticsFeatures.map((feature, index) => (
                <div key={index} className="logistics-item">
                  <div className="logistics-icon">
                    {feature.icon}
                  </div>
                  <div className="logistics-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Processing;